import { ComponentProps } from 'react';
import { Platform } from 'react-native';
import { startCase } from 'lodash';

import { Chip } from '@pimm/base';

type ChipVariant = ComponentProps<typeof Chip>['variant'];

export const ViolationTrigger = ({ value }: { value: string }) => {
  let variant: ChipVariant = 'ghost';
  switch (value?.toLowerCase()) {
    case 'l3':
      variant = 'error';
      break;
    case 'l2':
      variant = 'warning';
      break;
    case 'l1':
      variant = 'success';
      break;
    default:
  }

  return (
    <Chip
      _container={{ rounded: 'md', flex: Platform.OS === 'web' ? 'none' : 0 }}
      color={!variant ? 'black' : undefined}
      flat
      value={startCase(value)}
      variant={variant}
    />
  );
};
